// يضيف توكن الدخول تلقائيًا لكل طلب موجّه للـ API، ويعيد المستخدم لصفحة الدخول عند انتهاء الجلسة.
// الخادم يتطلب المصادقة على كل مسارات /api عدا تسجيل الدخول.
const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:5000/api";

export function installAuthFetch() {
  if (window.__authFetchInstalled) return;
  window.__authFetchInstalled = true;
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === "string" ? input : input?.url || "";
    const isApi = url.startsWith(API_BASE);
    if (!isApi) return originalFetch(input, init);

    const isLogin = url.startsWith(`${API_BASE}/login`);
    const headers = new Headers(init.headers || (typeof input !== "string" ? input.headers : undefined));
    const token = sessionStorage.getItem("token");
    if (token && !headers.has("Authorization")) headers.set("Authorization", `Bearer ${token}`);

    const res = await originalFetch(input, { ...init, headers });

    if (res.status === 401 && !isLogin && token) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/login")) window.location.assign("/login");
    }
    return res;
  };
}
